module.exports = __webpack_public_path__ + "static/media/last_card_sect.125b12a1.png";